import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { C, font } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import NotFound from "./NotFound";
import FaqSection from "../components/FaqSection";
import { applySeo, SITE_URL } from "../lib/seo";
import { posts, postsBySlug, loadPostBody } from "../data/blog";

function fmtDate(d) {
  try {
    return new Date(d + "T12:00:00").toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    return d;
  }
}

function setArticleJsonLd(post) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.seoDesc || post.excerpt,
    image: SITE_URL + post.cover,
    datePublished: post.date,
    dateModified: post.date,
    author: { "@type": "Organization", name: "IMOBMEET" },
    publisher: {
      "@type": "Organization",
      name: "IMOBMEET",
      logo: { "@type": "ImageObject", url: SITE_URL + "/logo512.png" },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": SITE_URL + "/" + post.slug },
  };
  let el = document.getElementById("post-jsonld");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "post-jsonld";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Barra de compartilhamento (WhatsApp, Facebook, copiar link)
function ShareBar({ url, title }) {
  const [copied, setCopied] = useState(false);
  const wa = `https://wa.me/?text=${encodeURIComponent(title + " " + url)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const t = document.createElement("textarea");
      t.value = url;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand("copy"); } catch {}
      document.body.removeChild(t);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontFamily: font,
    fontSize: 14,
    fontWeight: 700,
    padding: "11px 18px",
    borderRadius: 11,
    textDecoration: "none",
    border: "1.5px solid transparent",
    cursor: "pointer",
  };

  return (
    <div
      style={{
        marginTop: 44,
        paddingTop: 28,
        borderTop: `1px solid ${C.border}`,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <span style={{ fontFamily: font, fontSize: 14.5, fontWeight: 800, color: C.text, marginRight: 4 }}>
        Compartilhe:
      </span>
      <a href={wa} target="_blank" rel="noopener noreferrer" aria-label="Compartilhar no WhatsApp"
         style={{ ...base, background: "#25D366", color: "#fff" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.6 6.3A7.9 7.9 0 0 0 12 4a8 8 0 0 0-6.9 12l-1 3.8 3.9-1a8 8 0 0 0 3.9 1h.1a8 8 0 0 0 5.6-13.6zM12 18.5a6.6 6.6 0 0 1-3.4-.9l-.24-.15-2.3.6.6-2.24-.16-.25a6.6 6.6 0 0 1 10.3-8.2 6.6 6.6 0 0 1-4.8 11.3zm3.6-4.9c-.2-.1-1.2-.6-1.35-.65s-.31-.1-.44.1-.5.64-.62.77-.23.15-.43.05a5.4 5.4 0 0 1-1.6-1 6 6 0 0 1-1.1-1.37c-.12-.2 0-.3.08-.4l.3-.35c.1-.12.13-.2.2-.34s0-.25 0-.35-.44-1.06-.6-1.45-.32-.33-.44-.34h-.38a.72.72 0 0 0-.52.24 2.2 2.2 0 0 0-.68 1.62 3.8 3.8 0 0 0 .8 2 8.7 8.7 0 0 0 3.34 2.95c.47.2.83.32 1.11.42.47.15.9.13 1.23.08.38-.06 1.16-.48 1.32-.94s.17-.85.12-.94-.18-.13-.38-.23z"/>
        </svg>
        WhatsApp
      </a>
      <a href={fb} target="_blank" rel="noopener noreferrer" aria-label="Compartilhar no Facebook"
         style={{ ...base, background: "#1877F2", color: "#fff" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M22 12a10 10 0 1 0-11.56 9.87v-7H7.9V12h2.54V9.8c0-2.5 1.5-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.9h-2.34v7A10 10 0 0 0 22 12z"/>
        </svg>
        Facebook
      </a>
      <button onClick={copy} aria-label="Copiar link"
         style={{ ...base, background: copied ? "#ECFDF5" : C.surface, color: copied ? "#047857" : C.text,
                  borderColor: copied ? "#10B981" : C.border }}>
        {copied ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>
        )}
        {copied ? "Copiado!" : "Copiar link"}
      </button>
    </div>
  );
}

export default function BlogPost() {
  const { slug } = useParams();
  const post = postsBySlug[slug];
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!post) return;
    window.scrollTo(0, 0);
    applySeo({
      title: post.seoTitle || `${post.title} | IMOBMEET`,
      description: post.seoDesc || post.excerpt,
      path: "/" + post.slug,
      image: SITE_URL + post.cover,
    });
    setArticleJsonLd(post);
    let alive = true;
    setStatus("loading");
    loadPostBody(post.slug)
      .then((html) => {
        if (alive) {
          setBody(html);
          setStatus("ok");
        }
      })
      .catch(() => alive && setStatus("error"));
    return () => {
      alive = false;
      const el = document.getElementById("post-jsonld");
      if (el) el.remove();
    };
  }, [slug]);

  // Slug não é um post → 404 real (deixa outras rotas dinâmicas caírem aqui)
  if (!post) return <NotFound />;

  const cat = (post.categories && post.categories[0]) || null;
  const related = posts
    .filter(
      (p) =>
        p.slug !== post.slug &&
        (p.categories || []).some((c) => cat && c.slug === cat.slug)
    )
    .slice(0, 3);

  return (
    <>
      <Navbar />

      {/* Hero do post */}
      <section
        style={{
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(135deg, #0B1733 0%, #0A1230 100%)",
          padding: "108px 28px 44px",
        }}
      >
        <div className="grid-bg" style={{ position: "absolute", inset: 0, opacity: 0.22, pointerEvents: "none" }} />
        <div style={{ maxWidth: 760, margin: "0 auto", position: "relative" }}>
          <Link
            to="/conteudo"
            style={{
              fontFamily: font,
              fontSize: 13.5,
              fontWeight: 700,
              color: "#8FB3E6",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              marginBottom: 20,
            }}
          >
            ← Voltar para o Conteúdo
          </Link>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
            {(post.categories || []).slice(0, 3).map((c) => (
              <span
                key={c.slug}
                style={{
                  fontFamily: font,
                  fontSize: 11,
                  fontWeight: 800,
                  letterSpacing: 0.3,
                  color: "#fff",
                  background: "rgba(5,96,255,0.9)",
                  padding: "5px 11px",
                  borderRadius: 999,
                }}
              >
                {c.name}
              </span>
            ))}
          </div>
          <h1
            style={{
              fontFamily: font,
              fontSize: "clamp(28px, 4.4vw, 42px)",
              fontWeight: 800,
              lineHeight: 1.12,
              letterSpacing: -1.1,
              color: "#fff",
              margin: "0 0 18px",
            }}
          >
            {post.title}
          </h1>
          <div
            style={{
              fontFamily: font,
              fontSize: 14,
              color: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <span>Publicado em {fmtDate(post.date)}</span>
          </div>
        </div>
      </section>

      {/* Corpo */}
      <section style={{ background: C.surface, padding: "0 28px 72px" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          {/* Capa */}
          <img
            src={post.cover}
            alt={post.title}
            style={{
              width: "100%",
              borderRadius: 18,
              margin: "-40px 0 40px",
              boxShadow: "0 24px 60px rgba(10,15,30,0.22)",
              position: "relative",
              display: "block",
            }}
          />

          {status === "loading" && (
            <p style={{ fontFamily: font, color: C.muted }}>Carregando artigo…</p>
          )}
          {status === "error" && (
            <p style={{ fontFamily: font, color: C.muted }}>
              Não foi possível carregar este artigo.{" "}
              <Link to="/conteudo" style={{ color: C.accent }}>
                Ver todos os conteúdos
              </Link>
              .
            </p>
          )}
          {status === "ok" && (
            <div className="post-body" dangerouslySetInnerHTML={{ __html: body }} />
          )}

          {/* Compartilhar */}
          {status === "ok" && (
            <ShareBar url={SITE_URL + "/" + post.slug} title={post.title} />
          )}

          {/* Banner Portabilidade de CRM */}
          <Link
            to="/agendar-demo"
            className="portab-banner"
            style={{
              marginTop: 40,
              padding: "30px 34px",
              borderRadius: 20,
              background:
                "linear-gradient(120deg, #0560FF 0%, #0A47D8 55%, #204493 100%)",
              color: "#fff",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 24,
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 20px 44px rgba(5,96,255,0.28)",
            }}
          >
            <span
              aria-hidden="true"
              style={{
                position: "absolute",
                right: -40,
                top: "50%",
                transform: "translateY(-50%)",
                width: 260,
                height: 260,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(255,255,255,0.16), transparent 68%)",
                pointerEvents: "none",
              }}
            />
            <div style={{ position: "relative", zIndex: 1 }}>
              <div
                style={{
                  fontFamily: font,
                  fontSize: "clamp(26px, 3.4vw, 34px)",
                  fontWeight: 800,
                  letterSpacing: 0.4,
                  textTransform: "uppercase",
                  lineHeight: 1.02,
                  color: "#fff",
                  marginBottom: 12,
                }}
              >
                Portabilidade de CRM
              </div>
              <div
                style={{
                  fontFamily: font,
                  fontSize: 17,
                  fontWeight: 600,
                  letterSpacing: -0.2,
                  lineHeight: 1.35,
                  color: "rgba(255,255,255,0.9)",
                  maxWidth: 520,
                }}
              >
                Faça sua portabilidade de maneira digital e descomplicada.
              </div>
            </div>
            <span
              className="portab-cta"
              style={{
                position: "relative",
                zIndex: 1,
                flexShrink: 0,
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontFamily: font,
                fontSize: 15,
                fontWeight: 800,
                color: C.accent,
                background: "#fff",
                padding: "14px 26px",
                borderRadius: 12,
                boxShadow: "0 10px 26px rgba(0,0,0,0.20)",
                whiteSpace: "nowrap",
              }}
            >
              Agendar demonstração →
            </span>
          </Link>
        </div>
      </section>

      {/* FAQ (visível + schema FAQPage) */}
      {post.faq && post.faq.length > 0 && <FaqSection items={post.faq} />}

      {/* Relacionados */}
      {related.length > 0 && (
        <section style={{ background: C.bgAlt, padding: "64px 28px 88px" }}>
          <div style={{ maxWidth: 1180, margin: "0 auto" }}>
            <h2 style={{ fontFamily: font, fontSize: 26, fontWeight: 800, letterSpacing: -0.6, color: C.text, margin: "0 0 26px" }}>
              Continue lendo
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gap: 24,
              }}
            >
              {related.map((p) => (
                <Link
                  key={p.slug}
                  to={`/${p.slug}`}
                  style={{
                    background: C.surface,
                    border: `1px solid ${C.border}`,
                    borderRadius: 16,
                    overflow: "hidden",
                    textDecoration: "none",
                    color: C.text,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ aspectRatio: "16 / 9", overflow: "hidden", background: C.bgDeep }}>
                    <img src={p.cover} alt={p.title} loading="eager" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <div style={{ padding: "18px 20px 20px" }}>
                    <h3 style={{ fontFamily: font, fontSize: 16.5, fontWeight: 800, lineHeight: 1.3, margin: "0 0 8px", color: C.text }}>
                      {p.title}
                    </h3>
                    <span style={{ fontFamily: font, fontSize: 12.5, color: C.accent, fontWeight: 800 }}>Ler artigo →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
